import Vue from 'vue';
import Router from 'vue-router';

// Import the components
import Dibble from '../components/Dibble';
import Auth from '../components/Auth/Auth';
import Dashboard from '../components/Dashboard/Dashboard';
import Rental from '../components/Rental/index';
import RentalTable from '../components/Rental/RentalTable/index';
import BoatTypeInfo from '../components/Boat/BoatTypeInfo';
import ScanOrderQR from '../components/ScanOrderQR/ScanOrderQR';
// import RentalOrder from "../components/Rental/OrderPage/RentalOrder";
import AppUsersList from '../components/Users/AppUsers/UsersList';
import UsersList from '../components/Users/UsersList';
import Moorage from '../components/Moorage/Moorage';
import MoorageParkingMap from '../components/Moorage/MoorageParkingMap';
import MoorageTable from '../components/Moorage/MoorageTable/index';
import MoorageSlips from '../components/Moorage/MoorageSlips/MoorageSlips';
import MoorageOrder from '../components/Moorage/OrderPage/MoorageOrder';
import NoRentalDays from '../components/Rental/NoRentalDays';
import OrderSearch from '@/components/Rental/RentalTable/OrderSearch';
import Coupons from '@/components/Coupons/Coupons';
import RentalMap from '@/components/Rental/RentalMap/index';
import Discounts from '@/components/Discounts/Discounts';
import Calendar from '@/components/Calendar/Calendar';
import InfoOrder from '../components/RentalInfo/InfoOrder';
import CheckInPage from '../components/RentalInfo/CheckIn';
import PaymentPage from '../components/RentalInfo/Payment';
import NotesPage from '../components/RentalInfo/Notes';
import FilesPage from '../components/RentalInfo/File';
import SearchOrders from '@/components/Moorage/MoorageTable/SearchOrders.vue';
import MooragePayment from '@/components/Moorage/MooragePayment.vue';
import UpdatePayment from '@/components/Moorage/UpdatePayment.vue';
import { EventBus } from '@/utils/event-bus';
import Registration from '@/components/Registration/Registration.vue';

// Campaigns
import CampaignsListView from '@/components/campaigns/ListView';
import CampaignsCreateView from '@/components/campaigns/CreateView';
import CampaignsEdit from '@/components/campaigns/CampaignEdit.vue';
import CampaignsView from '@/components/campaigns/CampaignView.vue';
import CampaignDonations from '@/components/campaigns/Donations.vue';
import CampaignDistributions from '@/components/campaigns/Distributions.vue';

// Account
import AccountView from '@/components/account/AccountView.vue';
import Designations from "@/components/Designations/Designations.vue";
import DesignationDonations from "@/components/Designations/DesignationDonations.vue";
import CampaignDesignations from "@/components/campaigns/CampaignDesignations.vue";
import CampaignQuestions from "@/components/campaigns/CampaignQuestions.vue";
import WidgetList from "@/components/widgets/WidgetList.vue";
import WidgetPublicView from "@/components/widgets/WidgetPublicView.vue";
import WidgetPublicViewPayment
    from "@/components/widgets/WidgetPublicViewPayment.vue";
import DonationsList from "@/components/Donations/DonationsList.vue";
import SupportersList from "@/components/supporters/SupportersList.vue";
import SupporterView from "@/components/supporters/SupporterView.vue";
import DonationView from "@/components/Donations/DonationView.vue";
import CampaignPublicViewPayment
    from "@/components/widgets/CampaignPublicViewPayment.vue";

Vue.use(Router);

const router = new Router({
    mode: 'history',
    linkActiveClass: 'active',
    routes: definedRoutes(),
});
router.beforeEach((to, from, next) => {
    EventBus.$emit('clearSidebarSearchBox');
    next();
});

function definedRoutes() {
    const loggedUser = Vue.$cookies.get('_user');
    return [
        {
            path: '/login',
            name: 'Login',
            component: Auth,
        },
        {
            path: '/registration',
            name: 'Registration',
            component: Registration,
        },
        {
            path: '/',
            name: 'Home',
            component: Dibble,
        },
        {
            path: '/dashboard',
            name: 'Dashboard',
            component: Dashboard,
            meta: {
                breadcrumb: loggedUser ? loggedUser.account_name : '',
            },
        },
        {
            path: '/rental',
            name: 'Rental',
            component: Rental,
            meta: {
                breadcrumb: 'Rental',
            },
        },
        {
            path: '/rental/map',
            component: RentalMap,
            name: 'RentalMap',
        },
        {
            path: '/rental/:id',
            component: RentalTable,
            name: 'RentalOrderHistory',
            meta: {
                breadcrumb: 'Rental / Order history',
            },
        },
        {
            path: '/rental-history/:userId',
            component: RentalTable,
            name: 'RentalHistory',
            meta: {
                breadcrumb: 'Rental / User Rental Order history',
            },
        },
        {
            path: '/rental-search-order/:keyword',
            component: OrderSearch,
            meta: {
                breadcrumb: 'Rental / User Rental Order Search',
            },
        },
        {
            path: '/boat-type-info/:id',
            name: 'BoatTypeInfo',
            component: BoatTypeInfo,
            meta: {
                breadcrumb: 'Rental / Boat info',
            },
        },
        {
            path: '/scan-order-qr',
            component: ScanOrderQR,
        },
        {
            path: '/rental-order/:id/info',
            // component: RentalOrder // Old UI
            component: InfoOrder, // New UI
            name: 'RentalOrderInfo',
            meta: {
                breadcrumb: 'Rental  /  Sport boat  /  Order & user info',
            },
        },
        {
            path: '/users',
            component: UsersList,
            meta: {
                breadcrumb: loggedUser ? loggedUser.account_name : '',
            },
        },
        {
            path: '/app-users',
            name: 'AppUsersList',
            component: AppUsersList,
            meta: {
                breadcrumb: 'App Users',
            },
        },
        {
            path: '/moorage',
            component: Moorage,
            name: 'Moorage',
            meta: {
                breadcrumb: 'Moorage',
            },
        },
        {
            path: '/moorage-table/:id',
            component: MoorageTable,
            name: 'MoorageOrderTable',
            meta: {
                breadcrumb: 'Moorage  /  _id  /  Orders',
            },
        },
        {
            path: '/moorage-search-order/:keyword',
            component: SearchOrders,
            name: 'MoorageOrderTable',
            meta: {
                breadcrumb: 'Moorage  /  Search Orders',
            },
        },
        {
            path: '/moorage-slips/:id',
            component: MoorageSlips,
            name: 'MoorageSlips',
            meta: {
                breadcrumb: 'Moorage  /  _id  /  Table',
            },
        },
        {
            path: '/moorage-map/:id',
            name: 'MoorageMap',
            component: MoorageParkingMap,
            meta: {
                breadcrumb: 'Moorage  /  _id  /  Parking map',
            },
        },
        {
            path: '/moorage-order/:id',
            component: MoorageOrder,
            name: 'MoorageOrder',
        },
        {
            path: '/no-rental-days',
            name: 'NoRentalDays',
            component: NoRentalDays,
        },
        {
            path: '/coupons',
            component: Coupons,
        },
        {
            path: '/discounts',
            component: Discounts,
        },
        {
            path: '/calendar',
            component: Calendar,
        },
        {
            path: '/info-order',
            component: InfoOrder,
            meta: {
                breadcrumb: 'Rental  /  Sport boat  /  Order & user info',
            },
        },
        {
            path: '/rental-order/:id/reservation',
            name: 'RentalOrderReservation',
            component: CheckInPage,
            meta: {
                breadcrumb: 'Rental / Sport boat / check in & return',
            },
        },
        {
            path: '/rental-order/:id/payments',
            name: 'RentalOrderPayments',
            component: PaymentPage,
            meta: {
                breadcrumb: 'Rental  /  Sport boat  /  Payments',
            },
        },
        {
            path: '/rental-order/:id/notes',
            name: 'RentalOrderNotes',
            component: NotesPage,
            meta: {
                breadcrumb: 'Rental  /  Sport boat  /  Notes',
            },
        },
        {
            path: '/rental-order/:id/files',
            name: 'RentalOrderFiles',
            component: FilesPage,
            meta: {
                breadcrumb: 'Reservation  /  Sport boat  /  Files',
            },
        },
        {
            path: '/moorage-payment/:id',
            name: 'MooragePayment',
            component: MooragePayment,
            meta: {
                breadcrumb: 'Moorage Payment',
            },
        },
        {
            path: '/update-payment/:id',
            name: 'UpdatePayment',
            component: UpdatePayment,
            meta: {
                breadcrumb: 'Update Payment',
            },
        },
        {
            path: '/campaigns',
            name: 'CampaignsListView',
            component: CampaignsListView,
            meta: {
                breadcrumb: loggedUser ? loggedUser.account_name : '',
            },
        },
        {
            path: '/campaigns/create',
            name: 'CampaignsCreateView',
            component: CampaignsCreateView,
            meta: {
                breadcrumb: loggedUser ? loggedUser.account_name : '',
            },
        },
        {
            path: '/campaigns/edit/:id',
            name: 'CampaignEdit',
            component: CampaignsEdit,
            meta: {
                breadcrumb: loggedUser ? loggedUser.account_name : '',
            },
        },
        {
            path: '/campaigns/view/:id',
            name: 'CampaignsView',
            component: CampaignsView,
            meta: {
                breadcrumb: loggedUser ? loggedUser.account_name : '',
            },
        },
        {
            path: '/campaigns/:id/donations',
            name: 'CampaignDonations',
            component: CampaignDonations,
            meta: {
                breadcrumb: loggedUser ? loggedUser.account_name : '',
            },
        },
        {
            path: '/campaigns/:id/distributions',
            name: 'CampaignDistributions',
            component: CampaignDistributions,
            meta: {
                breadcrumb: loggedUser ? loggedUser.account_name : '',
            },
        },
        {
            path: '/campaigns/:id/designations',
            name: 'CampaignDesignations',
            component: CampaignDesignations,
            meta: {
                breadcrumb: loggedUser ? loggedUser.account_name : '',
            },
        },
        {
            path: '/campaigns/:id/questions',
            name: 'CampaignQuestions',
            component: CampaignQuestions,
            meta: {
                breadcrumb: loggedUser ? loggedUser.account_name : '',
            },
        },
        {
            path: '/designations/:id/donations',
            name: 'DesignationDonations',
            component: DesignationDonations,
            meta: {
                breadcrumb: loggedUser ? loggedUser.account_name : '',
            },
        },
        {
            path: '/designations',
            name: 'Designations',
            component: Designations,
            meta: {
                breadcrumb: loggedUser ? loggedUser.account_name : '',
            },
        },
        {
            path: '/account',
            name: 'Account',
            component: AccountView,
            meta: {
                breadcrumb: loggedUser ? loggedUser.account_name : '',
            },
        },
        {
            path: '/widgets',
            name: 'Widgets',
            component: WidgetList,
            meta: {
                breadcrumb: loggedUser ? loggedUser.account_name : '',
            },
        },
        {
            path: '/widgets/archive',
            name: 'Widgets Archive',
            component: WidgetList,
            meta: {
                breadcrumb: loggedUser ? loggedUser.account_name : '',
            },
        },
        {
            path: '/widgets/view/:id',
            name: 'WidgetPublicView',
            component: WidgetPublicView,
        },
        {
            path: '/campaign/payment/:id',
            name: 'CampaignPublicViewPayment',
            component: CampaignPublicViewPayment,
        },
        {
            path: '/widgets/payment/:id',
            name: 'WidgetPublicViewPayment',
            component: WidgetPublicViewPayment,
        },
        {
            path: '/donations',
            name: 'DonationsList',
            component: DonationsList,
            meta: {
                breadcrumb: loggedUser ? loggedUser.account_name : '',
            },
        },
        {
            path: '/donation/view/:id',
            name: 'DonationView',
            component: DonationView,
            meta: {
                breadcrumb: loggedUser ? loggedUser.account_name : '',
            },
        },
        {
            path: '/supporters',
            name: 'SupportersList',
            component: SupportersList,
            meta: {
                breadcrumb: loggedUser ? loggedUser.account_name : '',
            },
        },
        {
            path: '/supporter/view/:email',
            name: 'SupporterView',
            component: SupporterView,
            meta: {
                breadcrumb: loggedUser ? loggedUser.account_name : '',
            },
        },
    ];
}

export default router;
